import React from 'react';
import { Link } from 'react-router-dom';
import '../css/comman.css';
import {Navbar,NavbarBrand} from 'reactstrap';

function Footer(props){
    return(
        <div className="footer">
                <div className="row justify-content-center">             
                    <div className="mt-1">
                        <p>Version: 2.2.0</p>
                    </div>
            </div>
        </div>
    );
}

export default Footer;